module.exports = (fox) => {
  "use strict";

  fox.registerWidget(
    "RecaptchaFox",
    {
      init() {
        this.inVisibleKey = fox.getEnv("reCaptchaInvisible");
        this.visibleKey = fox.getEnv("reCaptchaVisible");
        this.id = null;
        this.captchaVariant = null;
        this._scriptStarted = false;
        this._renderTimer = null;

        this.callParent("init", arguments);
      },

      isNeed() {
        return !fox.isEmpty(this.inVisibleKey) || !fox.isEmpty(this.visibleKey);
      },

      load(event) {
        this._ensureScript();

        return this._waitForRecaptcha().then(() => {
          if (this.captchaVariant === "visible" && event !== "onError") {
            return;
          }

          if (!fox.isEmpty(this.inVisibleKey) && event !== "onError") {
            // v3 programmatic execute — no widget render needed
            this.captchaVariant = "invisible";
          } else if (!fox.isEmpty(this.visibleKey) && this.captchaVariant !== "visible") {
            // visible checkbox (only when visibleKey set, render=explicit mode)
            this._renderCaptcha("visible");
          } else if (this.id !== null) {
            this.reset();
          }
        });
      },

      _ensureScript() {
        if (this._scriptStarted) {
          return;
        }

        this._scriptStarted = true;
        const key = this.inVisibleKey || "explicit";
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${key}`;
        script.async = true;
        document.head.appendChild(script);
      },

      _waitForRecaptcha() {
        if (window.grecaptcha && window.grecaptcha.enterprise) {
          return Promise.resolve();
        }

        return new Promise((resolve) => {
          clearTimeout(this._renderTimer);
          this._renderTimer = setTimeout(() => {
            resolve(this._waitForRecaptcha());
          }, 200);
        });
      },

      _ensureInvisibleAnchor() {
        if (!this._invisibleAnchor) {
          this._invisibleAnchor = document.createElement("div");
          this._invisibleAnchor.style.cssText = "position:absolute;visibility:hidden;";
          document.body.appendChild(this._invisibleAnchor);
        }
        return this._invisibleAnchor;
      },

      _renderCaptcha(variant) {
        if (variant === "invisible") {
          this.id = window.grecaptcha.enterprise.render(
            this._ensureInvisibleAnchor(),
            {
              sitekey: this.inVisibleKey,
              size: "invisible",
              callback: (token) => {
                if (this._tokenResolve) {
                  this._tokenResolve(token);
                  this._tokenResolve = null;
                }
              },
              "error-callback": () => {
                if (this._tokenResolve) {
                  this._tokenResolve("");
                  this._tokenResolve = null;
                }
              },
            },
          );
        } else {
          this._getVisibleContainer().style.display = "block";
          this.id = window.grecaptcha.enterprise.render("ReCaptchaFox", {
            sitekey: this.visibleKey || this.inVisibleKey,
          });
        }

        this.captchaVariant = variant;
      },

      _getVisibleContainer() {
        return document.getElementById("ReCaptchaFox");
      },

      getToken(_actionName) {
        if (this.captchaVariant === "visible") {
          return Promise.resolve(
            window.grecaptcha.enterprise.getResponse(this.id),
          );
        }

        return this.load().then(() => {
          if (this.captchaVariant === "invisible") {
            return new Promise((resolve) => {
              window.grecaptcha.enterprise.ready(() => {
                window.grecaptcha.enterprise
                  .execute(this.inVisibleKey, { action: _actionName })
                  .then(resolve)
                  .catch(() => resolve(""));
              });
            });
          }

          return Promise.resolve(
            window.grecaptcha.enterprise.getResponse(this.id),
          );
        });
      },

      reset() {
        window.grecaptcha.enterprise.reset(this.id);
      },
    },
    "Controller",
  );
};



// WEBPACK FOOTER //
// ./components/login-wizard/widget/recaptcha.es.js